import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bag, luggage, buggage "} maskId="square-filled-radius-0-stroke-1-IconBag"><path fillRule="evenodd" clipRule="evenodd" d="M7.50171 3V7H2.00391V12H22.0017V7H16.5017V3H7.50171ZM15.5017 7V4H8.50171V7H15.5017Z" fill="currentColor"/><path d="M2.00391 21V13H11.5017V15.5H12.5017V13H22.0017V21H2.00391Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBag;
